import { createStore } from 'zustand'
import { createGlobalSlice } from './global'
import zustandMiddlewares from './middlewares'
import type { AllSlice } from './types'

interface CreateAllStoreOptsType {
  name?: string
}

export default function createAllStore(opts?: CreateAllStoreOptsType) {
  return createStore<AllSlice>()(
    zustandMiddlewares((...a) => ({
      name: opts?.name || 'zustand store',
      ...createGlobalSlice(...a),
    })),
  )
}
